.menu {
  position: fixed;
  z-index: 70;
  box-sizing: border-box;
  width: max-content;
  min-width: 220px;
  max-width: min(280px, calc(100vw - 16px));
  padding: 4px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  box-shadow: var(--shadow-pop);
  outline: none;
  /* Fade only: the menu has no positional motion (2026-10b §6.2). */
  animation: menu-in 100ms ease-out;
}

@keyframes menu-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .menu {
    animation-duration: 0.01ms;
  }
}

.item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-height: 36px;
  padding: 0 12px;
  background: transparent;
  border: 0;
  border-radius: var(--radius-xs);
  color: var(--text);
  font: inherit;
  font-size: var(--font-size);
  text-align: left;
  cursor: pointer;
}

.item:hover {
  background: var(--accent-soft);
}

/* Keyboard focus: soft fill plus a 2px inner accent ring (§6.2). */
.item:focus-visible,
.item[data-active='true'] {
  background: var(--accent-soft);
  outline: none;
  box-shadow: inset 0 0 0 2px var(--accent);
}

.icon {
  display: inline-flex;
  flex: none;
  color: var(--text-muted);
}

.label {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.shortcut {
  flex: none;
  margin-left: 16px;
  color: var(--text-muted);
  font-size: var(--font-size-sm);
}

.danger {
  color: var(--danger);
}

.danger .icon {
  color: var(--danger);
}

.danger:hover,
.danger:focus-visible,
.danger[data-active='true'] {
  background: var(--danger-soft);
}

.separator {
  height: 1px;
  margin: 4px 0;
  background: var(--border);
}
